import { Layout } from "antd";
import { Content, Footer, Header } from "antd/lib/layout/layout";
import React from "react";
import { Outlet } from "react-router-dom";
import logoImage from "../assets/images/eira_logo.png";

const AuthLayout = () => {
  return (
    <Layout className="bg-white" style={{ minHeight: "100vh" }}>
      <Header className="h-16 bg-custom_primary">
        <div className="max-w-7xl mx-auto h-16 flex flex-row items-center">
          <div className="flex-1">
            <img src={logoImage} className="h-8" alt="Motivia" />
          </div>
        </div>
      </Header>
      <Content className="flex justify-center items-center">
        <Outlet />
      </Content>
      <Footer className="h-auto bg-custom_primary">
        <div className="max-w-7xl mx-auto flex flex-row items-center">
          <div className="hidden md:flex flex-1">
            <img src={logoImage} className="h-8" alt="Motivia" />
          </div>
          <div className="flex-1 flex justify-center"></div>
          <div className="hidden md:flex flex-1"></div>
        </div>
      </Footer>
    </Layout>
  );
};

export default AuthLayout;
